<ion-content class="ion-padding" [class.mobile]="platform.is('capacitor')">
  <h1>Sollzeit</h1>
  <section>
    <div class="amount-item">
      <div class="hover-bttn" (click)="up('days')">
        <ion-icon name="fa-angle-right"></ion-icon>
      </div>
      <div class="input-sec">
        <input type="number" [(ngModel)]="amount.days" min="0" max="9999" #days inputmode="numeric" (focus)="toggleModalBreakpoint(days)">
        <label>Tage</label>
      </div>
      <div class="hover-bttn" (click)="down('days')">
        <ion-icon name="fa-angle-right"></ion-icon>
      </div>
    </div>
    <div class="amount-item">
      <div class="hover-bttn" (click)="up('hours')">
        <ion-icon name="fa-angle-right"></ion-icon>
      </div>
      <div class="input-sec">
        <input type="number" [(ngModel)]="amount.hours" min="0" max="23" #hours inputmode="numeric" (focus)="toggleModalBreakpoint(hours)">
        <label>Std.</label>
      </div>
      <div class="hover-bttn" (click)="down('hours')">
        <ion-icon name="fa-angle-right"></ion-icon>
      </div>
    </div>
    <div class="amount-item">
      <div class="hover-bttn" (click)="up('minutes')">
        <ion-icon name="fa-angle-right"></ion-icon>
      </div>
      <div class="input-sec">
        <input type="number" [(ngModel)]="amount.minutes" min="0" max="59" #minutes inputmode="numeric" (focus)="toggleModalBreakpoint(minutes)">
        <label>Min.</label>
      </div>
      <div class="hover-bttn" (click)="down('minutes')">
        <ion-icon name="fa-angle-right"></ion-icon>
      </div>
    </div>
    <div class="amount-item">
      <div class="hover-bttn" (click)="up('seconds')">
        <ion-icon name="fa-angle-right"></ion-icon>
      </div>
      <div class="input-sec">
        <input type="number" [(ngModel)]="amount.seconds" min="0" max="59" #seconds inputmode="numeric" (focus)="toggleModalBreakpoint(seconds)">
        <label>Sek.</label>
      </div>
      <div class="hover-bttn" (click)="down('seconds')">
        <ion-icon name="fa-angle-right"></ion-icon>
      </div>
    </div>
  </section>
</ion-content>